import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-skills",
  templateUrl: "./skills.component.html",
  styleUrls: ["./skills.component.scss"],
})
export class SkillsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  expertises = [
    {
      name: "UX",
      icon: "fa-laptop",
      description:
        "UX allows to dictate the skeleton of a website and think about what is the best approach for users to manage the site.",
    },
    {
      name: "UI",
      icon: "fa-magic",
      description:
        "The challenge is to find the best interaction and visual design for the user, each detail is important to analyze.",
    },
    {
      name: "FRONT-END",
      icon: "fa-code",
      description:
        "Bring design to life with HTML, CSS, and JavaScript. Is about making a quick and responsive code for the user interaction.",
    },
  ];

  frameworks = [
    { name: "Bootstrap", percentage: "width-100" },
    { name: "Wordpress", percentage: "width-100" },
  ];

  languages = [
    { name: "Spanish", percentage: "width-100" },
    { name: "English", percentage: "width-100" },
    { name: "Catalan", percentage: "width-50" },
  ];

  webSkills = [
    { name: "HTML & CSS", percentage: "width-100" },
    { name: "SASS & LESS", percentage: "width-100" },
    { name: "Javascript & jQuery", percentage: "width-90" },
    { name: "React", percentage: "width-70" },
    { name: "Angular", percentage: "width-70" },
    { name: "Git", percentage: "width-70" },
    { name: "Github", percentage: "width-90" },
    { name: "PHP", percentage: "width-50" },
  ];

  designSkills = [
    { name: "Sketch", percentage: "width-100" },
    { name: "Figma", percentage: "width-100" },
    { name: "Invision", percentage: "width-100" },
    { name: "Ilustrator", percentage: "width-100" },
    { name: "Photoshop", percentage: "width-100" },
    { name: "Indesign", percentage: "width-100" },
    { name: "Axure", percentage: "width-80" },
  ];

  methodologiesSkills = [
    { name: "Agile/Scrum Methodology", percentage: "width-90" },
    { name: "Information Architecture", percentage: "width-100" },
    { name: "User Research", percentage: "width-100" },
    { name: "User Journeys", percentage: "width-100" },
    { name: "User Flows", percentage: "width-100" },
    { name: "Usability Testing", percentage: "width-100" },
    { name: "Data Analysis", percentage: "width-100" },
    { name: "Wireframing", percentage: "width-100" },
    { name: "UI Design", percentage: "width-100" },
    { name: "Prototyping", percentage: "width-100" },
  ];
}



// WEBPACK FOOTER //
// ./src/app/skills/skills.component.ts